import React from 'react';

/** Support scene used by the empty inbox and the help card. */
export function QueryArt({ className = '', label = '' }: { className?: string; label?: string }) {
  return (
    <svg
      className={`hq-art ${className}`}
      viewBox="0 0 320 210"
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
    >
      <rect className="hq-art__sky" width="320" height="210" rx="28" />
      <circle cx="268" cy="34" r="14" fill="var(--ml-accent-soft, #ffe08a)" />
      <circle cx="42" cy="48" r="8" fill="#ffffff" opacity="0.75" />
      <circle cx="60" cy="40" r="12" fill="#ffffff" opacity="0.5" />
      <path
        className="hq-art__hill"
        d="M0 132c46-26 74 10 122-8 36-14 62 18 108-4 24-12 48 6 90-10v108H0z"
      />
      <path className="hq-art__hill2" d="M0 168c58-22 86 12 140-2 42-10 64 16 180-12v56H0z" />
      <g className="hq-art__bubble">
        <rect x="186" y="34" width="96" height="40" rx="16" fill="var(--ml-primary, #6d4dff)" />
        <path d="M208 74l-6 12 18-8z" fill="var(--ml-primary, #6d4dff)" />
        <circle cx="214" cy="54" r="3.2" fill="#fff" />
        <circle cx="232" cy="54" r="3.2" fill="#fff" />
        <circle cx="250" cy="54" r="3.2" fill="#fff" />
      </g>
      <path d="M108 58c-8 11-13 17-13 26a13 13 0 0 0 26 0c0-9-5-15-13-26z" fill="var(--ml-primary, #7c5cff)" />
      <circle cx="108" cy="84" r="3.6" fill="#fff" />
      <rect className="hq-art__card" x="54" y="86" width="176" height="90" rx="18" />
      <rect x="70" y="102" width="88" height="8" rx="4" fill="#d9ccff" />
      <rect x="70" y="118" width="132" height="6" rx="3" fill="var(--ml-primary-wash, #efeaff)" />
      <rect x="70" y="130" width="110" height="6" rx="3" fill="var(--ml-primary-wash, #efeaff)" />
      <circle cx="196" cy="152" r="14" fill="var(--ml-primary, #6d4dff)" />
      <path
        d="M190 152l4 4 8-9"
        fill="none"
        stroke="#fff"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
